module.exports = {
  hostname: "https://www.baldwinmatzus.com", // Must have protocol (https://www.esquiredigital.com)
  wordpressUrl: "https://staging-matzus2017.kinsta.cloud", // Must have protocol (http://edit.esquiredigital.com)
  cloudinaryURL:
    "https://res.cloudinary.com/nextlevel/image/fetch/f_auto,q_auto/",
  gtmCode: "GTM-5XF2RQ4", // e.g: GTM-NBH6CFM
  // Flags to stop building certain types of pages.
  // Useful if you want to deploy a partially done project without
  // all page templates done yet.
  buildTypes: {
    innerPages: true,
    blogPosts: true,
    blogIndexPages: true,
    categories: true,
  },
};
